import { Instagram, Facebook, Linkedin } from "lucide-react";

// TikTok icon component (not available in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: "https://www.instagram.com/thetakeoffgroup/?hl=en", label: "Instagram" },
    { icon: Facebook, href: "https://www.facebook.com/thetakeoffgroup/", label: "Facebook" },
    { icon: TikTokIcon, href: "https://www.tiktok.com/@takeoffmarketing", label: "TikTok" },
    { icon: Linkedin, href: "https://www.linkedin.com/company/takeoff-mtl", label: "LinkedIn" },
  ];

  return (
    <footer data-testid="footer" className="bg-dark-card border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <a
              href="#"
              data-testid="footer-logo"
              className="inline-block"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_automate-scale-4/artifacts/6ae3ntbm_TAKEOFF%20LOGOS%20%28350%20x%20180%20px%29%20%283%29.png" 
                alt="TAKEOFF Marketing Group"
                className="h-20 w-auto"
              />
            </a>
            <p className="font-body text-sm text-white/50 mt-4 leading-relaxed">
              Helping ambitious businesses grow faster through content that performs, strategy that converts, and systems that scale.
            </p>
          </div>

          {/* Montreal Location */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase text-white mb-4">
              Montreal, Quebec
            </h4>
            <address className="font-body text-sm text-white/50 not-italic leading-relaxed">
              383 Rue Saint-Zotique
              <br />
              Suite #2
              <br />
              Montreal, Quebec
            </address>
          </div>

          {/* Miami Location */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase text-white mb-4">
              Miami, Florida
            </h4>
            <address className="font-body text-sm text-white/50 not-italic leading-relaxed">
              333 Southeast 2nd Avenue
              <br />
              Suite 2000
              <br />
              Miami, FL 33131
            </address>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase text-white mb-4">
              Contact
            </h4>
            <div className="space-y-2">
              <a
                href="mailto:INFO@THETAKEOFFGROUP.COM"
                data-testid="footer-email"
                className="font-body text-sm text-white/50 hover:text-lime transition-colors block"
              >
                INFO@THETAKEOFFGROUP.COM
              </a>
              <a
                href="tel:+15142947552"
                data-testid="footer-phone"
                className="font-body text-sm text-white/50 hover:text-lime transition-colors block"
              >
                (514) 294-7552
              </a>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((social, index) => (
                <a
                  key={social.label}
                  href={social.href}
                  data-testid={`social-${social.label.toLowerCase()}`}
                  aria-label={social.label}
                  className="w-10 h-10 bg-dark border border-white/10 flex items-center justify-center hover:bg-lime hover:border-lime hover:text-black transition-all duration-300"
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">
            TAKEOFF MARKETING GROUP © {currentYear} / ALL RIGHTS RESERVED
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="font-body text-xs text-white/40 hover:text-lime transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="font-body text-xs text-white/40 hover:text-lime transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
